module.exports = __webpack_public_path__ + "1977939f6c0dac99c49d85a2b3a8d8ee.png";